import Education from '@/models-ts/user/Education'

const comparedFields = ['university', 'major', 'year', 'degree']

// @ts-ignore
export default (exp: Education) => comparedFields.some((field) => exp[field])
